import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useStore from "@/store";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import LoadingScreen from "@/components/LoadingScreen";

export function WorkpaceIdWorkflowIdRedirect() {
    const { workspaceId, workflowId } = useParams<{ workspaceId: string; workflowId: string }>();
    const navigate = useNavigate();

    const { currentWorkspace, switchWorkspace } = useCurrentWorkspace();

    useEffect(() => {
        if (workspaceId) {
            switchWorkspace(workspaceId);
        }
    }, [workspaceId, switchWorkspace]);

    const fetchWorkflowById = useStore((state) => state.fetchWorkflowById);
    const currentWorkflow = useStore((state) => state.getCurrentWorkflow());
    const workflowError = useStore((state) => state.workflowError);

    useEffect(() => {
        if (workflowId && (!currentWorkflow || currentWorkflow.id !== workflowId)) {
            fetchWorkflowById(workflowId);
        }
    }, [workflowId, fetchWorkflowById, currentWorkflow]);

    useEffect(() => {
        if (currentWorkspace && currentWorkflow && currentWorkflow.id === workflowId) {
            navigate(`/${currentWorkspace.url}/${currentWorkflow.url}/deploy`, { replace: true });
        }
    }, [currentWorkspace, navigate, currentWorkflow, workflowId]);

    useEffect(() => {
        if (workflowError) {
            console.error("🐞[DEBUG - WorkpaceIdWorkflowIdRedirect] error", workflowError);
            navigate("/");
        }
    }, [workflowError, navigate]);

    return <LoadingScreen />;
}
